<template>
    <ul class="domain-list">
        <li v-for="(domain, index) in form_urls" :key="index">
            <div class="domain-container">
                <input
                    type="text"
                    class="form-control"
                    placeholder="http://www.yourdomain.com"
                    v-model="form_urls[index]"
                    :class="[hasErrorInputClass('url.' + index)]"
                />
                <form-error-label
                    :target="formErrors['url.' + index]"
                    error-class="invalid-feedback"
                    role="alert"
                ></form-error-label>
            </div>
            <button
                class="btn btn-outline-danger btn-rounded btn-remove"
                aria-label="Remove"
                @click="removeDomain(index)"
                :disabled="form_urls.length <= 1"
            >
                <i class="dripicons-minus" aria-hidden="true"></i>
            </button>
            <button
                class="btn btn-outline-secondary btn-rounded btn-add"
                aria-label="Add"
                @click="addDomain()"
                v-if="index == form_urls.length - 1 && form_urls.length < 50"
            >
                <i class="dripicons-plus" aria-hidden="true"></i>
            </button>
        </li>
    </ul>
</template>

<script>
import { reactive, toRefs } from "@vue/composition-api";
import FormErrorLabel from "@/ui/FormErrorLabel";
export default {
    setup(props) {
        let { formErrors, hasErrorInputClass } = toRefs(props.formErrorHandler);
        // let formErrors = ref(props.formErrorHandler.formErrors);
        // let hasErrorInputClass = props.formErrorHandler.hasErrorInputClass;

        return {
            formErrors,
            hasErrorInputClass,
        };
    },
    components: {
        FormErrorLabel,
    },
    props: ["value", "formErrorHandler"],
    methods: {
        addDomain() {
            this.form_urls.push("");
        },
        removeDomain(index) {
            this.form_urls.splice(index, 1);
        },
    },
    computed: {
        form_urls: {
            get() {
                return this.value;
            },
            set() {
                this.$emit("update:value");
            },
        },
    },
    created() {
        if (this.form_urls?.length == 0) {
            this.form_urls.push("");
        }
    },
};
</script>

<style lang="scss" scoped>
.domain-list {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
        // height: rem-calc(36);
        margin-bottom: rem-calc(6);
        display: grid;
        grid-template-columns: 1fr repeat(2, #{rem-calc(24)});
        gap: rem-calc(12);
        align-items: center;

        // & > :first-child {
        //     flex: 1;
        // }

        & > input {
            grid-column: 1 / 2;
        }

        & > button {
            flex-shrink: 0;
            // margin-left: rem-calc(12);
            padding: 0;
            width: rem-calc(24);
            height: rem-calc(24);
            display: flex;
            align-items: center;
            justify-content: center;
            align-self: flex-start;
            margin-top: rem-calc((36 - 24 + 3) / 2);

            & > i {
                line-height: 0;
            }

            &.btn-remove {
                grid-column: 2 / 3;
            }
            &.btn-add {
                grid-column: 3 / 4;
            }
        }

        // &.create-form {
        //     height: rem-calc(38);
        //     margin-bottom: rem-calc(4);
        // }
    }
}
</style>